/* <cr-slider>: sliding row with dots (Color Recipes homepage + bundle page). Dots follow the swipe, are tappable, and hide when nothing slides. */
if (!customElements.get('cr-slider')) {
  customElements.define('cr-slider', class CrSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cr-slider__track');
      if (!this.track || this._ready) return;
      this._ready = true;
      this.cards = Array.from(this.track.children).filter((el) => el.nodeType === 1);
      if (this.cards.length < 2) return;
      this.dots = document.createElement('div');
      this.dots.className = 'cr-dots';
      this.dots.setAttribute('role', 'group');
      this.dots.setAttribute('aria-label', this.getAttribute('data-dots-label') || 'Slide position');
      this.cards.forEach((card, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'cr-dot';
        d.setAttribute('aria-label', (this.getAttribute('data-dot-label') || 'Show item') + ' ' + (i + 1));
        d.addEventListener('click', () => this.track.scrollTo({ left: Math.max(0, card.offsetLeft - this.gutter()), behavior: 'smooth' }));
        this.dots.appendChild(d);
      });
      this.track.after(this.dots);
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
      window.addEventListener('load', () => setTimeout(this.update, 50));
      requestAnimationFrame(this.update);
      setTimeout(this.update, 400);
    }
    gutter() {
      return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
    }
    update() {
      const t = this.track;
      const maxScroll = t.scrollWidth - t.clientWidth;
      this.dots.hidden = maxScroll <= 4;
      const step = this.cards[1].offsetLeft - this.cards[0].offsetLeft || 1;
      let idx = Math.round(t.scrollLeft / step);
      if (t.scrollLeft >= maxScroll - 3) idx = this.cards.length - 1;
      idx = Math.max(0, Math.min(this.cards.length - 1, idx));
      Array.from(this.dots.children).forEach((d, i) => d.classList.toggle('is-on', i === idx));
    }
  });
}
